import React from "react";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
/** Components Import */
import Pm10020View from "../../Views/Purchase/PM10020";
import Snackbar from "../../Components/Snackbar";

function PM10020(props) {
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [inputs, setInputs] = React.useState({
    comboCurrencyCd: [], //토화
    currencyCd: "", //통화
  });

  const [lanData, setLanData] = React.useState([]);
  const [rowData, setRowData] = React.useState([]);
  const [rowData1, setRowData1] = React.useState([]);
  const [changedRowData, setChangedRowData] = React.useState([]);
  const [changedRowData1, setChangedRowData1] = React.useState([]);
  const [selectedRowData, setSelectedRowData] = React.useState([]);
  const [selectedRowData1, setSelectedRowData1] = React.useState([]);
  const today = new Date();
  const monthAgo = new Date(today);
  const [startDate, setStartDate] = React.useState(
    monthAgo.setMonth(today.getMonth() - 3)
  );
  const [endDate, setEndDate] = React.useState(new Date());

  React.useEffect(() => {
    window.addEventListener("error", (e) => {
      if (e.message === "ResizeObserver loop limit exceeded") {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client- overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
    SearchLogic();
  }, []);

  const SearchLogic = async () => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];
    let getComboData = [];
    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);

      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Purchase.PM10020.GetPurchaseOrders,
        {
          StartDate: new Date(startDate),
          EndDate: new Date(endDate),
        }
      ).then((result) => {
        let data = result.data;
        let currencyCd1 = "";
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: getLanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else if (data.type === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: getLanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          for (let i = 0; i < data.length; i++) {
            getRowData.push({
              poNo: data[i].poNo,
              poCreatDt: data[i].poCreatDt
                ? Commons.DateFormating(data[i].poCreatDt.toString(), 2)
                : "",
              custNm: data[i].custNm,
              createId: data[i].createId,
              delivDt: data[i].delivDt
                ? Commons.DateFormating(data[i].delivDt.toString(), 2)
                : "",
              poStusCode: data[i].poStusCode,
              // inWh: data[i].inWh,
              // inWhNm: data[i].inWhNm,
              arriveCustCd: data[i].arriveCustCd,
              poType: data[i].poType,
              poTypeNm: data[i].poTypeNm,
              currencyCd: data[i].currencyCd,
              poDelivReqDt: data[i].poDelivReqDt
                ? Commons.DateFormating(data[i].poDelivReqDt.toString(), 2)
                : "",
              reference: data[i].reference,
              filePath: data[i].filePath,
            });
          }
          setRowData(Commons.InsertNumber(getRowData));
        }
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const GetPurchaseOrderDtls = async (_pono) => {
    Dialog.ProgressBar(true);
    let getRowData = [];
    // setPoNoSave(_pono);
    // selectedPoNo = _pono;
    try {
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Purchase.PM10020.GetPurchaseOrderDtls,
        { poNo: _pono }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else if (data.type === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else if (data.length === 0) {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
          setRowData1([]);
        } else {
          for (let i = 0; i < data.length; i++) {
            getRowData.push({
              itemCd: data[i].itemCd,
              itemNm: data[i].itemNm,
              itemStd: data[i].itemStd,
              poItemQty: data[i].poItemQty,
              poAddItemQty: data[i].poAddItemQty,
              itemUnit: data[i].itemUnit,
              itemStdAmt: data[i].itemStdAmt,
              poItemAmt: data[i].poItemQty * data[i].itemStdAmt,
              poItemVat: data[i].poItemVat,
              poRemarkDtl: data[i].poRemarkDtl,
              poItemCost: data[i].poItemCost,
              whNm: data[i].whNm,
            });
            setRowData1(Commons.InsertNumber(getRowData));
          }
        }
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  return (
    <>
      <Pm10020View
        rowData={rowData}
        setRowData={setRowData}
        rowData1={rowData1}
        SearchLogic={SearchLogic}
        setRowData1={setRowData1}
        changedRowData={changedRowData}
        setChangedRowData={setChangedRowData}
        setSelectedRowData={setSelectedRowData}
        changedRowData1={changedRowData1}
        setChangedRowData1={setChangedRowData1}
        setSelectedRowData1={setSelectedRowData1}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        GetPurchaseOrderDtls={GetPurchaseOrderDtls}
        lanData={lanData}
      />
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
    </>
  );
}

export default PM10020;
